import React from "react";
import { Box, Flex, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FiCompass, FiCreditCard, FiHome, FiLogOut, FiUsers } from "react-icons/fi";
import { NavLink, useNavigate } from "react-router-dom";
import { ArawaksLogo } from "../../components/utils/ArawaksLogo";
import { logOut } from "lib/auth";

const ITEMS = [
  { to: "/perfil", label: "Resumen", icon: FiHome, end: true },
  { to: "/perfil/familia", label: "Familia", icon: FiUsers },
  { to: "/perfil/registro", label: "Registros", icon: FiCompass },
  { to: "/perfil/pagos", label: "Pagos", icon: FiCreditCard },
];

export default function NavbarPerfil() {
  return <HStack
    as="nav" display={{ base: "flex", lg: "none" }} bg="public.bg.panel/94" backdropFilter="blur(12px)" px="2" pt="2" pb="calc(8px + env(safe-area-inset-bottom))"
    borderTopWidth="1px" borderColor="public.border.subtle" justify="space-around"
    position="fixed" bottom="0" left="0" right="0" zIndex="10"
  >
    {ITEMS.map((item) => <NavLink key={item.to} to={item.to} end={item.end} style={{ flex: 1, textDecoration: "none" }}>
      {({ isActive }) => <VStack gap="1" py="2" color={isActive ? "brand.red" : "public.fg.subtle"} position="relative">
        <Icon as={item.icon} boxSize="20px" strokeWidth={isActive ? "2.5" : "2"}/>
        <Text fontSize="10px" fontWeight={isActive ? "800" : "600"}>{item.label}</Text>
        <Box position="absolute" top="0" w="22px" h="3px" rounded="full" bg={isActive ? "brand.red" : "transparent"}/>
      </VStack>}
    </NavLink>)}
  </HStack>;
}

export function PerfilDesktopSidebar() {
  const navigate = useNavigate();
  const logout = async () => { await logOut(); navigate("/registro", { replace: true }); };
  return <Flex as="aside" display={{ base: "none", lg: "flex" }} direction="column" w="250px" flexShrink="0" minH="100dvh" px="6" py="7" bg="public.bg.panel/92" backdropFilter="blur(12px)" borderRightWidth="1px" borderColor="public.border.default">
    <ArawaksLogo alt="Arawaks" w="142px" h="40px"/>
    <Text mt="2" color="public.fg.subtle" fontSize="xs" fontWeight="700">Portal familiar</Text>
    <VStack as="nav" align="stretch" gap="1" mt="10">
      {ITEMS.map((item) => <NavLink key={item.to} to={item.to} end={item.end} style={{ textDecoration: "none" }}>
        {({ isActive }) => <HStack minH="46px" px="4" rounded="14px" bg={isActive ? "brand.redSubtle" : "transparent"} color={isActive ? "brand.redFg" : "public.fg.muted"} fontWeight={isActive ? "800" : "650"} _hover={{ bg: isActive ? "brand.redSubtle" : "public.bg.muted", color: "public.fg.default" }}>
          <Icon as={item.icon} boxSize="19px"/><Text fontSize="sm">{item.label}</Text>
        </HStack>}
      </NavLink>)}
    </VStack>
    <Box flex="1"/>
    <HStack as="button" type="button" minH="44px" px="4" rounded="14px" color="public.fg.muted" _hover={{ bg: "brand.redSubtle", color: "brand.redFg" }} onClick={logout}><FiLogOut/><Text fontSize="sm" fontWeight="700">Cerrar sesión</Text></HStack>
  </Flex>;
}
